import React from 'react';

import {
  DateTimePicker,
  DateTimePickerProps
} from '../../DateTimePicker';

import { useStyles } from './styles';

import { Show } from 'shared/components';
import { DateTimePickerIcon } from './DateTimePickerIcon/DateTimePickerIcon';
import { DateTimePickerArrowIcon } from './DateTimePickerArrowIcon/DateTimePickerArrowIcon';
import { DatePickerClearButton } from './DatePickerClearButton/DatePickerClearButton';

export const IconedDateTimePicker = ({
  icon,
  hideBorderBottom = false,
  showClearButton = true,
  showArrowIcon = true,
  ...props
}: IconedDateTimePickerProps) => {
  const { onChange, value, defaultValue } = props;
  const classes = useStyles({ hideBorderBottom, hasIcon: !!icon, inputVariant: props.inputVariant });

  return (
    <>
      <div className={classes.container}>
        <DateTimePickerIcon
          icon={icon}
        />
        <DateTimePicker
          {...props}
          classes={{
            datePicker: classes.datePicker
          }}
        />
        <Show when={showClearButton}>
          <DatePickerClearButton
            show={defaultValue !== value}
            onClick={() => {
              if (onChange && defaultValue) {
                onChange(defaultValue);
              }
            }}
          />
        </Show>
        <Show when={showArrowIcon}>
          <DateTimePickerArrowIcon
            classes={{
              root: classes.arrowIcon
            }}
            color={props.inputVariant === 'filled' ? 'inherit' : 'secondary'}
          />
        </Show>
      </div>
    </>
  )
};

export interface IconedDateTimePickerProps extends DateTimePickerProps {
  icon?: string;
  hideBorderBottom?: boolean;
  showClearButton?: boolean;
  showArrowIcon?: boolean;
}